<sd-modal-default
  [(isOpened)]="isOpened"
  (isOpenedChange)="isOpenedChange.emit($event)"
  modalCustomClass="c__tile-modal is-large"
  [titleHidden]="false"
  [modalTitleLevel]="tileTitleLevel"
  [modalTitle]="tileModal?.title"
>
  @if (isMobile$) {
    @if (tileModal?.subtitle) {
      <sd-title customClass="brand--h4 is-regular" [titleLevel]="tileTitleLevel + 1">
        {{tileModal?.subtitle}}
      </sd-title>
    }
  }

  <div class="c__tile-modal-body {{'is-' + tileModal?.layout}}">
    <div class="c__tile-media">
      @for (media of tileModal?.medias; track media) {
        <sd-banner
          [mediaTitle]="media?.mediaTitle"
          [videoTitle]="tileModal?.title"
          [hasAltText]="false"
          (mediaPlay)="onVideoPlayed(media?.mediaTitle)"
          (mediaEnded)="onVideoEnded(media?.mediaTitle)"
          [media]="media"
        />
      }
    </div>
    <div class="c__tile-text">
      @if (!isMobile$) {
        @if (tileModal?.subtitle) {
          <sd-title customClass="brand--h4 is-regular" [titleLevel]="tileTitleLevel + 1">
            {{tileModal?.subtitle}}
          </sd-title>
        }
      }

      <div class="c__content">
        <sd-html [html]="tileModal?.description" innerClass="is-body-m is-wysiwyg" />
        @if (tileModal?.link && tileModal?.link.url && tileModal?.link.linkName) {
          <sd-link [link]="tileModal?.link">
            <span class="{{isMobile$ ? 'is-body-m' : isTablet$ ? 'is-body-xl' : 'is-body-m'}}">
              {{tileModal?.link.linkName}}
            </span>
          </sd-link>
        }
      </div>
    </div>
  </div>
</sd-modal-default>
